module.exports = __webpack_public_path__ + "static/media/dots-3-horizontal.05b12ca0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/album-view/images/dots-3-horizontal.svg
// module id = 1022
// module chunks = 57